import { render } from "./lessonsSelector.vue?vue&type=template&id=61494e34&ts=true"
import script from "./lessonsSelector.vue?vue&type=script&lang=ts"
export * from "./lessonsSelector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__